import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-199c98e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "has-background-dark has-text-centered has-text-light navbar footer-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "is-block small-text" }, [
  /*#__PURE__*/_createTextVNode(" The source code is licensed "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://opensource.org/licenses/mit-license.php",
    class: "has-text-light has-text-weight-semibold mit",
    target: "__blank"
  }, " MIT ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "is-block" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://github.com/slotovi4/survey-creator",
    class: "has-text-light has-text-weight-semibold bi bi-github",
    target: "__blank"
  })
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, _hoisted_4))
}